module.exports = __webpack_public_path__ + "img/zs.8ae6548e.png";